import {createReducer} from '@reduxjs/toolkit';
import {UserDto} from '../dto/UserDto';
import {ProfileDto} from '../dto/ProfileDto';
import {clearUser, fetchUser, fetchUserProfile} from './actions';

type InitialState = {
    isFetching: boolean;
    user: UserDto | null;
    profile: ProfileDto | null;
    error: boolean;
};

const initialState: InitialState = {
    isFetching: false,
    user: null,
    profile: null,
    error: false
};

export const auth = createReducer(initialState, (builder) =>
    builder
        .addCase(fetchUser.pending, (state) => ({...state, isFetching: true}))
        .addCase(fetchUser.fulfilled, (state, action) => ({...state, isFetching: false, user: action.payload}))
        .addCase(fetchUser.rejected, (state) => ({...state, isFetching: false, error: true}))
        .addCase(fetchUserProfile.pending, (state) => ({...state, isFetching: true}))
        .addCase(fetchUserProfile.fulfilled, (state, action) => ({
            ...state,
            isFetching: false,
            profile: action.payload
        }))
        .addCase(fetchUserProfile.rejected, (state, action) => ({...state, isFetching: false, error: true}))
        .addCase(clearUser, (state) => ({...state, user: null, profile: null}))
);
